<template lang="html">
  <div class="pageContainer">
    <p class="text-right mx-4 my-3"><router-link :to="{ name: 'Index' }">Back Home</router-link></p>
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-8 col-md-6 col-lg-4 mx-auto">
          <h1 class="text-center">Forgot Password</h1>
          <form>
            <div class="form-group my-4">
              <label for="inputEmail">Email address</label>
              <input type="email" class="form-control" id="inputEmail" placeholder="Enter email">
            </div>
            <button type="submit" class="btn btn-primary">Retrieve Password</button>
          </form>
          <p class="mt-4 text-center">Recover your password? <router-link :to="{ name: 'Login' }">Login</router-link></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {

    }
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue